'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sheet as ShadSheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { useReturnFocus } from './useReturnFocus';
export function Sheet({ open, onClose, title, children }) {
    const returnFocus = useReturnFocus(open);
    return (_jsx(ShadSheet, { open: open, onOpenChange: (next) => {
            if (!next)
                onClose();
        }, children: _jsxs(SheetContent, { side: "bottom", className: "max-h-[85dvh] overflow-y-auto rounded-t-xl", onCloseAutoFocus: returnFocus, children: [_jsx(SheetHeader, { children: _jsx(SheetTitle, { className: "text-xl", children: title }) }), _jsx("div", { className: "px-4 pb-4", children: children })] }) }));
}
//# sourceMappingURL=Sheet.js.map